import React         from 'react';
import PropTypes     from 'prop-types';

class RoundedLabel extends React.Component {
	/**
	 * @return {String}
	 */
	render() {
		if (this.props.text === false) {
			return null;
		}

		return (
			<div className="label-round">
				<div className="label-round--bottom" />
				<div className="label-round--top" />
				<div className="label-round--text">{this.props.text}</div>
			</div>
		);
	}
}

RoundedLabel.propTypes = {
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

RoundedLabel.defaultProps = {
	text: false,
};

export default RoundedLabel;
